<script>
  // router : https://gitlab.inria.fr/ink-interaction/list-widgets/-/tree/master/node_modules/svelte-spa-router
  import { onMount } from "svelte";
  import { urlServeur, tabcouleur, pathImages } from "../components/conf.js";
  import Formations from "../components/PersonneFormation.svelte";
  import SyntheseSal from "../components/PersonneSyntheseSal.svelte";

  export let params = {};

  let id;

  const getID = () => {
    return params.id;
  };

  /**
   * Autre solution de fetch => appel directement dans le #wait
   */
  const fetchInfoPersonne = (async () => {
    id = getID();
    //console.log("Personne : " + id);
    const response = await fetch(urlServeur + "/api_employe/employe/id/" + id);
    const rest = await response.json();
    //console.dir(rest.payload);
    return rest.payload[0];
  })();

  onMount(async () => {});
</script>

{#await fetchInfoPersonne then element}
  <div class="row">
    <div class="col-xs-2 float-sm-left">
      <img
        src="{pathImages}team/avatar_{element.EM_PARTI_LE == '1970-01-01'
          ? element.EM_ID
          : '00'}.jpg"
        style="width:90px;"
        alt="User"
      />
    </div>

    <div class="carte_corps col-xs-9 float-sm-left">
      <strong
        >{element.EM_NOM}{#if element.EM_CADRE == 1}
          <span class="text-danger"> (Cadre)</span>
        {/if}</strong
      >
      <p
        style="background-color:#{element.EM_PARTI_LE == '1970-01-01'
          ? tabcouleur[element.EM_POSTE]
          : '04A2FC'}"
      >
        {element.EM_POSTE.substr(0, 25)}<span class="text-warning"
          >{element.EM_ALTERNANT == 1 ? " - (Alternant)" : ""}</span
        >
      </p>
    </div>
  </div>
{/await}

<h3>Synthèse salaires</h3>
<SyntheseSal {id} />

<h3>Liste des formations</h3>
<Formations {id} />

<style>
  h3 {
    font-size: 0.75em;
    color: rgba(16, 101, 227, 0.969);
  }
  .carte_corps {
    padding-left: 5px;
    margin-bottom: 15px;
  }
</style>
